<template>
  <div class="wrapper extras-container" :class="{'browser-wrapper': !isIos}" :style="iosOrAndroidStyle" v-show="loadingPageOver">
    <w-navbar v-show="iosOrAndroidShow" :icon="'iconchevron-left'" :nav_title="sectionTitle"
              @mobileLeftBtn="backToEditor" :right_btn_html="rightBtnHtml" @mobileRightBtn="complete"/>
    <div v-if="!loadingShow || loadingOver">
      <w-cv-form :formList="otherForm" :req="formData" @changeLabel="changeLabel"
                 @selectExtrasLabel="selectExtrasLabel">
        <div :slot="`suggest-${suggestField}`" v-if="suggest">
          <suggest-card @handleClose="changeSuggestState"/>
        </div>
      </w-cv-form>
      <div class="more-operate flex-start footer">
        <div class="flex-center delete" @click="deleteInfoConfirm" v-if="showDeleteIcon">
          <span class="iconfont iconshanchu"></span>
          <span>删除</span>
        </div>
        <div class="flex-center experience" v-if="showExperience">
          <w-tooltip v-if="experienceTooltipShow" class="w-tooltip" @handleClose="closeToolTip"></w-tooltip>
          <span class="iconfont iconbox"></span>
          <span @click="changeExperienceState">经历库</span>
        </div>
        <div class="flex-center tips" @click="changeTipsStatus">
          <span class="iconfont iconwenhao"></span>
          <span>小贴士</span>
        </div>
      </div>
    </div>
    <cv-tips :state="cvTipShow" @handleClose="changeTipsStatus"/>
    <experience-dialog :radio="true" :state="experienceState" :title="sectionTitle"
                       @selectExperience="selectExtrasExperience" ref="experienceDialog"
                       @deleteExperience="deleteExperience" @handleClose="changeExperienceState"></experience-dialog>
    <change-module-name :state="otherState" :module-name="otherTitle" :section-info="sectionInfo" title="修改标题"
                        @handleClose="changeState"/>
    <w-loading v-if="loadingShow"/>
  </div>
</template>

<script>
	import WNavbar from '@/components/global/w-navbar'
	import WCvForm from '@/components/cv/w-cv-form'
	import WLoading from '@/components/global/w-loading'
	import changeModuleName from '../../cv-components/change-module-name'
	import experienceDialog from '../../cv-experience/experience-dialog'
	import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
	import { moduleMixin } from '../../../assets/js/mixin/cv'
	import { componentsMixin } from '../../../assets/js/mixin/components'
	import { envMixin, eventMixin } from '../../../assets/js/mixin/global'
	import { userMixin } from '../../../assets/js/mixin/user'

	let { otherForm } = require('@/assets/json/cv')

	export default {
		mixins: [ componentsMixin, moduleMixin, envMixin, eventMixin, userMixin ],
		data () {
			return {
				otherForm,
				loadingShow: true,
				otherState: false, // 修改名称的弹窗
				otherTitle: '', // 修改的名称
				sectionInfo: {}, //
				experienceState: false, // 经历库弹窗
				formData: {
					// skill: {},
					// language: {},
					// other: {},
					// interest: {},
					// certificate: {}
				}, // 页面数据
				fromName: ''
			}
		},
		components: {
			WNavbar,
			WCvForm,
			WLoading,
			changeModuleName,
			experienceDialog
		},
		async created () {
			setTimeout(() => {
				this._initOtherInfos()
			}, 0)
		},
		beforeRouteLeave (to, from, next) {
			// this.$db.ls.remove('req')
			next()
		},
		watch: {},
		computed: {
			...mapState('cv', [ 'cv', 'currentInfo', 'extra', 'others' ]),
			...mapGetters('cvExperience', [ 'currentExperience' ]),
			showExperience () {
				let experience = false
				for (let key in this.currentExperience) {
					if (this.currentExperience[key].length) experience = true
				}
				return experience
			},
			showDeleteIcon () {
				let { submodule_info: { sections_position }, basic_info: { kind } } = this.cv
				for (let i = 0; i < sections_position.length; i++) {
					if (sections_position[i].type === 'extras' && kind !== 'sample' && kind !== 'template') {
						return true
					}
				}
			}
		},
		methods: {
			...mapActions('cv', [ 'createExtra', 'updateExtra', 'createCvDetail', 'updateCvDetail', 'getOtherInfo', 'getAssistInfo', 'getShowNpsState' ]),
			...mapMutations('cv', [ 'changeCurrentInfo' ]),
			...mapActions('cvExperience', [ 'getExtrasExperience' ]),
			...mapMutations('cvExperience', [ 'changeExperienceField' ]),
			// 选完经历后点击确定
			selectExtrasExperience (formData) {
				this.formData = formData
				this.changeCurrentInfo(this.formData)
				this.changeExperienceState()
			},
			// 点击去选择label
			selectExtrasLabel (item) {
				let { token } = this.$route.params
				let { add } = this.$route.query
				let search = item.otherSearch ? true : false
				this.$router.push({
					path: `/cvs/${ token }/extras/label`,
					query: {
						add,
						search: search,
						type: item.field
					}
				})
			},
			// 返回事件
			backToEditor () {
				let { basic_info: { token } } = this.cv
				if (this.verifyExtraData()) {
					this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '还有内容尚未保存，确定离开吗?',
						onConfirm: () => {
							this.$fn.redirect(
								`${window.location.origin}/cvs/${ token }/editor`,
								() => {
									this.$router.replace(`/cvs/${ token }/editor`)
								}
							)
						}
					}).show()
				} else {
					this.$fn.redirect(
            `${window.location.origin}/cvs/${ token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ token }/editor`)
            }
          )
				}
			},
			// 修改名称弹窗的状态
			changeState () {
				this.otherState = !this.otherState
			},
			// 点击名称旁边的修改
			changeLabel (label, item) {
				this.changeState()
				this.otherTitle = label
				this.sectionInfo = {
					titleInfo: {
						...item,
						type: 'extras-info'
					}
				}
			},
			verifyExtraData () {
				let localData = this.$db.ls.get('req')
				let keys = this.formData ? Object.keys(this.formData) : []
				for (let i = 0; i < keys.length; i++) {
					if (localData[keys[i]].description !== this.formData[keys[i]].description) return true
				}
			},
			// 删除经历
			deleteExperience (val, item) {
				this.$createDialog({
					title: '提示',
					type: 'confirm',
					content: `删除无法还原,确定删除?`,
					onConfirm: async () => {
						try {
							let res = await this.$api.cv.deleteExtra({
								[`${ item.type.slice(0, -1) }_id`]: val.id
							})
							if (res.code === 1000) {
								this.currentExperience[item.type] = this.currentExperience[item.type].filter(i => i.id !== val.id)
								if (!this.showExperience) {
									this.changeExperienceState()
								}
							} else {
								this.$createDialog({
									type: 'alert',
									content: '该段经历在其他简历被使用，无法删除',
									confirmBtn: '我知道了',
								}).show()
							}
						} catch (e) {
							console.log(e)
						}
					}
				}).show()
			},
			// 点击完成
			async complete () {
				if (!this.infoNotEmpty(this.formData, 'extras')) {
					this.showToast('完善经历信息，更容易获得青睐哦', 2000)
					return
				}
				let diffExtras = this.verifyExtrasChange()
				if (diffExtras) {
					let data = await this.verifyExtra()
					if (data && data.length) {
						this.$createDialog({
							title: '修改同步提示',
							type: 'confirm',
							content: `此段经历在其他简历中被引用，<br>是否同步修改到其他简历？`,
							confirmBtn: '同步',
							cancelBtn: '不同步',
							onConfirm: () => {
								this.experienceChange()
							},
							onCancel: () => {
								this.experienceChange(data)
							}
						}).show()
					} else {
						this.experienceChange()
					}
				} else {
					this.experienceChange()
				}
        this.getShowNpsState()
				// this.experienceChange()
				// console.log(payload, position, 'payload====')
			},
			// 判断extra里面有无被其他简历引用的内容
			async verifyExtra () {
				let payload = {}
				for (let key in this.formData) {
					if (this.formData[key].id) {
						payload[`${ key }_id`] = this.formData[key].id
					}
				}
				let res = await this.$api.cv.verifyExtra(payload)
				if (res.code === 80144) {
					return res.data.imported_arr
				} else if (res.code === 1000) {
					return []
				}
			},
			// 创建和更新extras内容
			async experienceChange (data) {
				let { submodule_info, basic_info } = this.cv
				let createPayload = {
					section_lang: basic_info.lang
				}
				let updatePayload = {
					section_lang: basic_info.lang
				}
				for (let key in this.formData) {
					if (this.formData[key].description) {
						if (!this.formData[key].id || this.formData[key].kind === 'sample' || (data && data.includes(key))) {
							createPayload[key] = this.formData[key]
						} else {
							updatePayload[key] = this.formData[key]
						}
					}
				}
				if (createPayload && Object.keys(createPayload).length > 1) await this.createExtra(createPayload)
				if (updatePayload && Object.keys(updatePayload).length > 1) await this.updateExtra(updatePayload)
				await this._updateCvDetail()
			},
			// 更新简历或者创建简历
			async _updateCvDetail () {
				let { operation } = this.$route.query
				let { token } = this.$route.params
				let { basic_info, submodule_info } = this.cv
				let subModuleInfo = JSON.parse(JSON.stringify(submodule_info))
				subModuleInfo.sections_position.forEach(item => delete item.title)

				let payload = {
					operation_type: basic_info.kind === 'template' || basic_info.kind === 'sample' ? '' : 'update_submodule_info',
					submodule_info: {}
				}
				let position = []
				if (operation === 'createModule') {
					position = [ ...subModuleInfo.sections_position, { type: 'extras', id: null, info_ids: [] } ]
				} else {
					position = subModuleInfo.sections_position
				}
				let extrasData = {}

				if (basic_info.kind === 'template' || basic_info.kind === 'sample') {
					for (let key in this.extra) {
						subModuleInfo[`${ key }_id`] = this.extra[key] && this.extra[key].id && this.extra[key].description ? this.extra[key].id : null
					}
					let basic_info = {
						...this.cv.basic_info,
						source_cv_token: this.cv.basic_info.token || null,
						sample_cv_source_token: this.cv.basic_info.token || null, // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
						token: null,
						kind: null
					}
					let res = await this.createCvDetail({
						basic_info,
						submodule_info: subModuleInfo,
						format_info: this.cv.format_info,
						operation_type: ''
					})
					if (res.code === 3001) {
						this.showToast(res.message)
						return
					}
					this.$fn.redirect(
            `${window.location.origin}/cvs/${ this.cv.basic_info.token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
            }
          )
				} else {
					for (let key in this.extra) {
						payload.submodule_info[`${ key }_id`] = this.extra[key] && this.extra[key].description ? this.extra[key].id : null
					}
					payload.submodule_info.sections_position = position
					await this.updateCvDetail({ token, payload })
					this.$fn.redirect(
            `${window.location.origin}/cvs/${ token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ token }/editor`)
            }
          )
				}
			},
			// 删除other模块
			deleteInfoConfirm () {
				this.dialog = this.$createDialog({
					title: '提示',
					type: 'confirm',
					content: `删除无法还原,确定删除?`,
					onConfirm: async () => {
						let { token } = this.$route.params
						let { submodule_info: { sections_position } } = this.cv
						let payload = {
							operation_type: 'update_submodule_info',
							submodule_info: {
								skill_id: null,
								language_id: null,
								certificate_id: null,
								other_id: null,
								interest_id: null,
								sections_position: sections_position.filter(item => item.type !== 'extras')
							}
						}
						await this.updateCvDetail({ token, payload })
						this.$fn.redirect(
							`${window.location.origin}/cvs/${ token }/editor`,
							() => {
								this.$router.replace(`/cvs/${ token }/editor`)
							}
						)
					}
				}).show()
			},
			// 对比当前和选中的other是否有更改
			verifyExtrasChange () {
				let diffExtras = {}
				for (let key in this.formData) {
					if (this.formData[key].id) {
						const k = `${ key }s`
						const index = this.currentExperience[k].findIndex(val => val.id === this.formData[key].id)
						if (index > -1 && this.currentExperience[k][index].description !== this.formData[key].description) {
							diffExtras[key] = this.formData[key]
						}
					}
				}
				if (Object.keys(diffExtras).length) {
					return diffExtras
				}
			},
			// 选中经历库当前数据
			_initCheckedData () {
				for (let key in this.formData) {
					this.currentExperience[`${ key }s`].forEach(val => {
						val.checked = this.formData[key].id === val.id
					})
				}
			},
			currentInfoNotEmpty() {
				for (let i in this.currentInfo) {
					if (this.currentInfo[i].description) return true
				}
			},
			// 初始化数据
			async _initOtherInfos () {
				this._getAssistInfo('faqs')
				let { add, operation } = this.$route.query
				if (!Object.keys(this.extra).length && this.currentInfo && !this.currentInfoNotEmpty()) {
					let req = {
						skill: {
							name: '技能',
							description: null
						},
						language: {
							name: '语言',
							description: null
						},
						other: {
							name: '活动',
							description: null
						},
						interest: {
							name: '兴趣',
							description: null
						},
						certificate: {
							name: '证书/执照',
							description: null
						}
					}
					this.changeCurrentInfo(req)
					this.$db.ls.set('req', JSON.parse(JSON.stringify(this.currentInfo)))
				} else if (this.fromName === 'editor') {
					this.changeCurrentInfo(this.extra)
					this.$db.ls.set('req', JSON.parse(JSON.stringify(this.currentInfo)))
				}
				this.formData = this.currentInfo
				await this.getExtrasExperience({ payload: { section_lang: this.cv.basic_info.lang } })
				this.changeExperienceField('extras')
				this._initCheckedData()
				this.loadingShow = false
				this.loadingOver = true
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/cv/module';
</style>
